// extracted by mini-css-extract-plugin
export default {"table":"Fornitori_table__7FbJL","DesktopOnly":"Fornitori_DesktopOnly__Yk-+g","MobileOnly":"Fornitori_MobileOnly__7H6Rr"};